


export const ErrorInterceptor = (error) => {

    console.log(error)

    //console.log(error)
    if (error.message == 'Network Error') {
        return Promise.reject(new Error('Erro de conexão'))
    }

    console.log(error.response)
    /* if(error.code == "ERR_BAD_REQUEST"){
         localStorage.setItem('tk_hsp','')
         window.location.href = '/login';
         return Promise.reject(new Error('Usuário não autrizado'))
     }*/
    if (error.response.data == "Unauthorized.") {
        localStorage.setItem('tk_hsp', '')
        localStorage.setItem('us_hsp', '')
        window.location.href = '/login';
        return Promise.reject(new Error('Usuário não autorizado'))
    }


    return Promise.reject(error.response);


}